<template>
  <div>
    <v-select
      v-model="parentModel"
      variant="outlined"
      density="compact"
      persistentPlaceholder
      hideDetails
      :disabled="disabled"
      :items="parentItems"
      itemTitle="name"
      itemValue="value"
      placeholder="Select configuration"
      class="segment-builder--subtypes _subtypes"
      height="32px"
      bgColor="#ffffff"
      style="min-width: 180px"
      :menuProps="{ maxHeight: 410, offsetY: true }"
      @update:modelValue="updateParent"
    />
    <div v-if="parentModel" class="segment-builder--item next-selection">
      <RfChevronIcon class="fill-beige-50 mx-1 my-auto h-6 w-6 rotate-180" />
      <v-select
        v-model="negativeMatch"
        class="min-w-28"
        variant="outlined"
        density="compact"
        persistentPlaceholder
        hideDetails
        height="32px"
        :disabled="disabled"
        itemTitle="text"
        :items="matchTypeItems"
        placeholder="Match Type"
        bgColor="#ffffff"
        @update:modelValue="updateFilter"
      />
    </div>
    <div v-if="negativeMatchSelected" class="segment-builder--item next-selection">
      <RfChevronIcon class="fill-beige-50 mx-1 my-auto h-6 w-6 rotate-180" />
      <component
        :is="childComponent"
        v-bind="childProps"
        v-model="childModel"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import { startCase, camelCase } from "lodash-es";
import CountryList from "country-list";
import RfAutoCompletionWithChips from "@/components/RfAutoCompletionWithChips.vue";
import RfGooglePlaceAutoCompletion from "@/components/RfGooglePlaceAutoCompletion.vue";
import { LocationTypes, USStates, DMAs } from "@/utils/constants/LocationsConstants";
import { MatchTypeItems } from "@/utils/constants/SegmentsConstants";
import { useSegmentStore } from "@/pinia/segmentStore";
import RfChevronIcon from "../icons/RfChevronIcon.vue";

export default {
  name: "RfLocation",
  components: {
    cities: RfGooglePlaceAutoCompletion,
    states: RfAutoCompletionWithChips,
    countries: RfAutoCompletionWithChips,
    metro_codes: RfAutoCompletionWithChips,
    postal_codes: RfGooglePlaceAutoCompletion,
    RfChevronIcon,
  },
  props: ["filter", "disabled"],
  setup: () => ({
    states: Object.keys(USStates),
    matchTypeItems: Object.values(MatchTypeItems),
    parentItems: Object.values(LocationTypes),
    segmentStore: useSegmentStore(),
  }),
  data: () => ({ parentModel: null, childModel: null, negativeMatch: null }),
  computed: {
    cities() {
      return "cities";
    },
    metroCodes() {
      return Object.values(DMAs).sort();
    },
    countries() {
      const names = CountryList.getNames();
      return names.map(country => {
        return { text: country, value: CountryList.getCode(country) };
      });
    },
    childComponent() {
      return this.parentModel;
    },
    parent() {
      return LocationTypes[this.parentModel];
    },
    childProps() {
      const varname = camelCase(startCase(this.parent.value));
      return { [this.parent.prop]: this[varname] };
    },
    locationKey() {
      return Object.keys(this.filter.location)[0];
    },
    values() {
      if (!this.parent) return [];

      return this.filter.location[this.parent.value];
    },
    negativeMatchSelected() {
      return this.negativeMatch !== null;
    },
  },
  watch: {
    childModel() {
      this.updateFilter();
    },
  },
  mounted() {
    this.prepareFilter();
  },
  methods: {
    updateParent() {
      this.childModel = [];
      this.updateFilter();
    },
    updateFilter() {
      const filter = {
        location: { [this.parentModel]: this.childModel },
        location_configs: { [this.parentModel]: { negative_match: this.negativeMatch } },
      };
      this.$emit("update:model", filter);
    },
    prepareFilter() {
      this.parentModel = this.locationKey;
      this.childModel = this.values;
      let configs;
      if (this.filter.location_configs) {
        configs = this.filter.location_configs;
      } else if (this.segmentStore.segment.filter.location_configs) {
        configs = this.segmentStore.segment.filter.location_configs;
      }
      if (configs[this.parentModel]) {
        this.negativeMatch = configs[this.parentModel].negative_match;
      }
    },
  },
};
</script>
